import React, { useState, useEffect } from "react";
import {
  Table,
  Form,
  Col,
} from "react-bootstrap";
import "./Bugs.css";
import { useAuth } from "../../ProtectedRoute/AppContext";
import { toast, ToastContainer } from "react-toastify";
import AxiosInstance from "../../Services/AxiosInstance";
import { API_ENDPOINTS } from "../../Services/BugService";
import { useNavigate } from "react-router";
import Loader from "../../DesignLayout/Loader/Loader";

// import Multiselect from 'multiselect-react-dropdown';
const Bugs = () => {
  const { user } = useAuth();
  const [Loading,setLoading]=useState(false);
  const [bugs, setBugs] = useState([]);
  const [tasks, setTask] = useState([]);
  const [priority, setPriority] = useState([]);
  const[status,setStatus]=useState([]);
  const [showModal, setShowModal] = React.useState(false);
  const[users,setUser]=useState([]);
  const[projects,setProjects]=useState([]);
  const navigate = useNavigate();
   const [image, setImage] = useState(null);
   const [preview, setPreview] = useState(null);
  const [filteredBugs, setFilteredBugs] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [taskFilter, setTaskFilter] = useState("");
  const [priorityFilter, setPriorityFilter] = useState("");
  const [dueDateFilter, setDueDateFilter] = useState("");
  const [projectFilter, setprojectFilter] = useState("");
const [statusfilter, setstatusfilter] = useState("");
const [bugAssignedTo, setbugAssignedTo] = useState([]);
const buguser=bugAssignedTo.map((item) => item.userId).join(',')
const date = new Date();
const formatDateForInput = (date) => {
  const tzOffset = new Date(date).getTimezoneOffset() * 60000; // Adjust for timezone offset
  const localISOTime = new Date(date - tzOffset).toISOString();
  return localISOTime.slice(0, 16); // Remove milliseconds and 'Z'
};

const [newBug, setNewBug] = useState({
    bugName: "",
    projectTaskId:0,
    createdBy: user.userId,
    assignedTo:'0',
    dueDate: formatDateForInput(date), // Format for "datetime-local"
    status: 1,
    priority: 1,
    bugDescription: "",
    expectedDate:'',
  FilePath:'',
  note:""
  });

 const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 12; // Number of items per page
const maxPageButtons = 10; // Maximum page buttons to display


// file upload old logic

  // Convert file to Base64
  const fileToBase64 = (input) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);

      if (input instanceof File || input instanceof Blob) {
        reader.readAsDataURL(input);
      } else {
        reject(
          new Error("Unsupported input type. Only File or Blob is allowed.")
        );
      }
    });
  };

  // Handle file upload
  const handleFileChange = async (e) => {
    const file = e.target.files[0] || "0";
    if (file) {
      try {
        const base64File = await fileToBase64(file);
        setImage(base64File);
        setNewBug((prev) => ({
          ...prev,
          filePath: base64File,
        }));
        
      } catch (error) {
        console.error("Error converting file to Base64:", error);
        toast.error("Failed to process the file.");
      }
    }
  };

  const handlePaste = (e) => {
    const items = e.clipboardData.items;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type.indexOf("image") !== -1) {
        const blob = items[i].getAsFile(); // Get the image as a File object
        if (blob) {
          // Convert the image into base64 format
          const reader = new FileReader();
          reader.onloadend = () => {
           
            setImage(blob); // Set the File object
            setPreview(reader.result); // Set the preview (base64 string)
          };
  
          reader.readAsDataURL(blob); // Convert blob to base64
        }
      }
    }
  };
  

  const totalPages = filteredBugs ? Math.ceil(filteredBugs.length / itemsPerPage) : 0;

// Slice the tasks for the current page
const currentTasks = (filteredBugs || []).slice(
  (currentPage - 1) * itemsPerPage,
  currentPage * itemsPerPage
);


// Function to handle page change
const handlePageChange = (pageNumber) => {
  if (pageNumber >= 1 && pageNumber <= totalPages) {
    setCurrentPage(pageNumber);
  }
};

// Generate page numbers dynamically
const generatePageNumbers = () => {
  const startPage = Math.max(1, currentPage - Math.floor(maxPageButtons / 2));
  const endPage = Math.min(totalPages, startPage + maxPageButtons - 1);
  return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
};


useEffect(() => {
  const fetchBugs = async () => {
    const params = { userId: user.sessionId };
    try {
      const response = await AxiosInstance.get(
        `${API_ENDPOINTS.GET_BUG_LIST_PAGE}?userId=${params.userId}`
      );
      const bugsById = response.data.bugsById || []; // Default to empty array
      const bugsData = response.data.bugs || [] // Default to empty array
  console.log(bugsById);
  
  if (bugsById.length > 0) {
    setBugs(bugsById); // bugsById is used if available
    setFilteredBugs(bugsById);
  } else if (bugsData.length > 0){
    setBugs(bugsData); // bugsById is used if available
    setFilteredBugs(bugsData);
  } else {
        setBugs([]);
        setFilteredBugs([]);
      }
      setStatus(response.data.status || []);
      setPriority(response.data.priority || []);
      setUser(response.data.users || []);
      setProjects(response.data.projects || []);
      setTask(response.data.tasks || []);
    } catch (error) {
      console.error(error);
      setFilteredBugs([]); // Ensure filteredBugs is always an array
    }
  };
  fetchBugs();
}, [user.userId]);

 // Handle the task update

  const [showProjectSession, setShowBugSession] = useState(false); // Track which section to show

  const handleModalClose = () => {
    setShowBugSession(false);
  };
  // Update this in the onClick event of the "Create Bug" button
  const handleCreate = () => { console.log("Create Bug Button Clicked");
    setShowBugSession(true); // Show bug section
  };
  useEffect(() => {
    let updatedBugs = [...bugs];

    if (searchQuery) {
      updatedBugs = updatedBugs.filter((bug) =>
        bug.bugName.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    if (priorityFilter) {
      updatedBugs = updatedBugs.filter((bug) => bug.priority === priorityFilter);
    }

    if (taskFilter) {
      updatedBugs = updatedBugs.filter((bug) => bug.projectTaskId === taskFilter);
    }

    if (dueDateFilter) {
      updatedBugs = updatedBugs.filter(
        (bug) => new Date(bug.dueDate).toISOString().split("T")[0] === dueDateFilter
      );
    }
    if(statusfilter){
      updatedBugs = updatedBugs.filter((task) => task.status === statusfilter);
    }
    if(projectFilter){
      updatedBugs = updatedBugs.filter((task) => task.projectName === projectFilter);
    }

    setFilteredBugs(updatedBugs);
  }, [searchQuery, priorityFilter, taskFilter, dueDateFilter, statusfilter, projectFilter, bugs]);

  const handleClick = (bugId) => {
    
      navigate("/bugdetails", { state: { bugId } });
  
  };

  const selectedUsersbug = (tasks && tasks.length > 0 && tasks[0].assignedToPerson)
  ? tasks[0].assignedToPerson.split(", ").map((item) => {
      const [id, name] = item.split(": ");
      return { value: id.trim(), label: name.trim() };
    })
  : []; // Default to an empty array if no task or assignedToPerson is not available
 // Default to an empty array if no task or assignedToPerson is not available
 // Default to an empty array if assignedTo is not available
    const [BugAssignedTo, setBugAssignedTo] = useState(selectedUsersbug);
  // const assignedTobug = String(newBug.assignedTo || ''); // Fallback to empty string if undefined
  // const selectedUsersbug = users.filter((user) => { 
  //   return user.userId && assignedTobug.split(',').includes(user.userId.toString());
  // });
  
   // Handle selection
   const onUserSelect = (selectedList) => {
    setBugAssignedTo(selectedList);
    // Join selected user ids into a comma-separated string
    const selectedUserIds = selectedList.map((item) => item.userId).join(',');
    setNewBug((prevTask) => ({
      ...prevTask,
      assignedTo: selectedUserIds, // Store as a string
    }));
  };
  
  // Handle removal
  const onUserRemove = (selectedList) => {
    setBugAssignedTo(selectedList);
    // Join remaining selected user ids into a comma-separated string
    const selectedUserIds = selectedList.map((item) => item.userId).join(',');
    setNewBug((prevTask) => ({
      ...prevTask,
      assignedTo: selectedUserIds, // Store as a string
    }));
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case "High":
      case "1":
        return "#d32121";
      case "Medium":
      case "2":
        return "#d4f004";
      case "Low":
      case "3":
        return "#04f0d1";
      case "Critical":
      case "4":
        return "#f00404";
      default:
        return "#dc3545";
    }
  };

  const AddBug = async (e) => {
    e.preventDefault();
setLoading(true);
    try {
      const formData = new FormData();
      if (image) {
        formData.append("image", image);  // Append the image file
        // formData.append("FilePath", image); // Use the image name
    } else {
        formData.append("FilePath", null); // Default value if no image is uploaded
    }

    
     const mergedBug={
      ...newBug,
      assignedTo:newBug.assignedTo || buguser,
      
     }
     for (const key in mergedBug) {
      formData.append(key, mergedBug[key]);
    }
    
  


  
    const response = await AxiosInstance.post(API_ENDPOINTS.POST_BUG,formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      
      if (response) {
        sessionStorage.setItem("toastMessage","bug created successfully")
         window.location.reload()
         } else {
          sessionStorage.setItem("toastMessage","Failed to create bug")
          window.location.reload()
       }
    } catch (error) {
      
      const validationErrors = error.response?.data?.Errors;
      if (validationErrors) {
        localStorage.setItem("toastMessage", validationErrors.join(", "));
    } else {
        localStorage.setItem("toastMessage", "An error occurred");
    }
    window.location.reload();
     
    }finally{
      setLoading(false);
    }
  };

  window.onload = () => {
    const message = sessionStorage.getItem("toastMessage");
    if (message) {
        toast.success(message);
        sessionStorage.removeItem("toastMessage"); // Clear after showing
    }
};

  const getStatusName = (statusId) => {
    const statusObj = status.find((item) => item.id === statusId);
    return statusObj ? statusObj.name : "Unknown"; // Fallback to "Unknown"
  };
  
  const getPriorityName = (priorityId) => {
    const priorityObj = priority.find((item) => item.id === priorityId);
    return priorityObj ? priorityObj.name : "Unknown";
  };
  
  const getAssignedToName = (userId) => {
    const userObj = users.find((item) => item.userId === parseInt(userId));
    return userObj ? userObj.userName : "Unassigned";
  };

  const handlefile = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
  
      // Preview the image
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  }

  return (
    <div className="bug-page">
      <ToastContainer/>
      <Loader loading={Loading} />
      <div className="box">
        <div className="d-flex">
        {!showProjectSession &&(
          <>
          <Col md={2}>
            <Form.Control
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search Bug Name"
            />
          </Col>

          <Col md={2} className="ms-3">
  <Form.Select
    value={taskFilter}
    onChange={(e) => setTaskFilter(e.target.value)}
  >
    <option value="">All Tasks</option>
    {tasks.map((task) => (
      <option key={task.projectTaskId}>
        {task.taskName}
      </option>
    ))}
  </Form.Select>
</Col>
<Col md={2} className="ms-3">
<Form.Select
 value={projectFilter}
 onChange={(e) => setprojectFilter(e.target.value)}
>
  
  <option value=''>All Projects</option>
              {projects.map((projectname)=>(
                <option key={projectname.projectId}>{projectname.projectName}</option>
              ))}
</Form.Select>
          </Col>

          <Col md={2} className="ms-3">
            <Form.Select
              value={priorityFilter}
              onChange={(e) => setPriorityFilter(Number(e.target.value))}
            >
              <option value="">All Priorities</option>
              {priority.map((priorityname)=>(
                <option key ={priorityname.id} value={priorityname.id}>{priorityname.name}</option>
              ))}
              {/* <option>High</option>
              <option>Medium</option>
              <option>Low</option>
              <option>Critical</option> */}
            </Form.Select>
          </Col>
            <Col md={1} className="ms-3">
                      <Form.Select  value={statusfilter}
                        onChange={(e) => setstatusfilter(Number(e.target.value))}
          >
                        <option value=''>All Status</option>
                        {status.map((statusname)=>(
                          <option key={statusname.id} value={statusname.id}>{statusname.name}</option>
                        ))}
                        {/* <option>Open</option>
                        <option>InProgress</option>
                        <option>OnHold</option>
                        <option>Completed</option>  
                        <option>Skipped</option>
                        <option>ToBeTested</option> */}
           
                      </Form.Select>
                    </Col>

          <Col md={1} className="ms-3">
            <Form.Control
              type="date"
              value={dueDateFilter}
              onChange={(e) => setDueDateFilter(e.target.value)}
            />
          </Col>
          </>
          )}
          <Col md={1} className="ms-3">
  {user &&
    (user.permission.includes(1)===true || user.role === 1 || user.role === 2 || user.role === 4) && (
      <button className="btn btn-primary" onClick={handleCreate}>
        Create Bug
      </button>
    )}
</Col>
        
        </div>
{!showProjectSession &&(
        <Table striped bordered hover responsive className="shadow-sm mt-3">
          <thead className="table-primary">
            <tr>
              <th>BugId</th>
              <th>Bug Name</th>
              <th>Task Name</th>
              <th>Reported Date</th>
              <th>Created By</th>
              <th>Status</th>
              <th>Assigned To</th>
              <th>Priority</th>
              <th>Due Date</th>
            </tr>
          </thead>
          <tbody>
            {currentTasks.map((bug) => (
              <tr key={bug.bugId} onClick={() => handleClick(bug.bugId)}>
                <td>BG-{bug.bugId}</td>
                <td>{bug.bugName}</td>
                
                <td>{bug.projectTaskId}</td>
                
                <td
  className="tdata"
  style={{ backgroundColor: "#ebecedd7" }}
  colSpan="1"
>
  {new Date(bug.reportingDate).toLocaleString("en-GB", {
    weekday: "short", // "Thu"
    day: "2-digit", // "23"
    month: "short", // "Jan"
    year: "numeric", // "2025"
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false, // Use 24-hour format
  })}
</td>
                <td>{bug.createdBy}</td>
                <td
      style={{
        backgroundColor:
          getStatusName(bug.status) === "Open"
            ? "#ffc107"
            : getStatusName(bug.status) === "InProgress"
            ? "#198754"
            : getStatusName(bug.status) === "OnHold"
            ? "#17a2b8"
            : getStatusName(bug.status) === "Completed"
            ? "#28a745"
            : getStatusName(bug.status) === "ToBeTested"
            ? "#0d6efd"
            : "#dc3545",
        color: "white",
        textAlign: "center",
      }}
    >
      {getStatusName(bug.status)}
    </td>
    <td>{getAssignedToName(bug.assignedTo)}</td>
    <td
      style={{
        backgroundColor:
          getPriorityName(bug.priority) === "High"
            ? "#d32121"
            : getPriorityName(bug.priority) === "Medium"
            ? "#d4f004"
            : getPriorityName(bug.priority) === "Low"
            ? "#04f0d1"
            : getPriorityName(bug.priority) === "Critical"
            ? "#f00404"
            : "#f0040f",
        color: "white",
        textAlign: "center",
      }}
    >
      {getPriorityName(bug.priority)}
    </td>
                <td>{new Date(bug.dueDate).toISOString().split("T")[0]}</td>
              </tr>
            ))}
          </tbody>

          {/* Pagination Navigation */}
<tr>
  <td colSpan={8}>

 
<div className="pagination-container mt-3 d-flex justify-content-center">
  <nav>
    <ul className="pagination">
      {/* Previous Button */}
      <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
        <button
          className="page-link"
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Previous
        </button>
      </li>

      {/* Page Number Buttons */}
      {generatePageNumbers().map((pageNumber) => (
        <li
          key={pageNumber}
          className={`page-item ${pageNumber === currentPage ? 'active' : ''}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(pageNumber)}
          >
            {pageNumber}
          </button>
        </li>
      ))}

      {/* Next Button */}
      <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
        <button
          className="page-link"
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next
        </button>
      </li>
    </ul>
  </nav>
</div>

</td>
</tr>
        </Table>
        )}
      </div>
      {showProjectSession && (
                <form onSubmit={AddBug}  enctype="multipart/form-data">
                  <Table striped bordered hover responsive className="shadow-sm mt-3">
                    <thead className="table-primary">
                      <tr>
                        <th>Bug Name</th>
                        <th>Task Name</th>
                        <th>Due Date</th>
                        <th>Priority</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <input
                            type="text"
                            value={newBug.bugName} // Use newBug first, fallback to default bug
                            onChange={(e) =>
                              setNewBug((prev) => ({
                                ...prev,
                                bugName: e.target.value,
                              }))
                            }
                            name="bugName"
                            id="bugName" className="form-control" required
                          />
                        </td>
                        <td>
                        < select name="projectTaskId" onChange={(e)=>setNewBug({
                          ...newBug,
                          projectTaskId: Number(e.target.value)
                        })} id=""  className="form-control" required>
                          <option value="" >Select Task</option>
                          {tasks.map((data)=>(
                            <option key={data.projectTaskId} value={data.projectTaskId}>{data.taskName}</option>
                          ))}
                        </select>
                        </td>
      
                        <td>
                          <input
                            type="date"
                            name="dueDate" className="form-control" required
                            value={newBug.dueDate} // Use newBug first, fallback to default bug
                            onChange={(e) =>
                              setNewBug((prev) => ({
                                ...prev,
                                dueDate: e.target.value,
                              }))
                            }
                            defaultValue={""}
                          />
                        </td>
      
                        <td
                          style={{
                            backgroundColor: getPriorityColor(newBug.priority),
                            color: "white",
                            textAlign: "center",
                          }}
                        >
                          <select
                            name="priority" className="form-control"
                            value={newBug.priority} // Use newBug first, fallback to default bug
                            onChange={(e) =>
                              setNewBug((prev) => ({
                                ...prev,
                                priority: e.target.value,
                              }))
                            }
                          >
                            {priority.map((priorityData) => (
                              <option value={priorityData.id} key={priorityData.id}>
                                {priorityData.name}
                              </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                      <br />
                      
                      <tr>
                     
                        <th className="thead table-primary">Assigned To</th>
                        <td
                              className="tdata"
                              style={{ backgroundColor: "#ebecedd7" }}
                            >

                          
                         <select name="assignedTo" id="assignedTo" className="form-control" value={newBug.assignedTo} onChange={(e)=>setNewBug({
                          ...newBug,
                          assignedTo:e.target.value
                         })} >
                          <option value="0">Select Developers</option>
                          
                          {users.map((user) => (
                            <option value={user.userId} key={user.userId}>{user.userName}</option>
                          ))}
                         </select>
                            </td>



                        {user.role === 1 && (
                          <>
                            <th className="table-primary">Expected Date</th>
                            <td
                              className="tdata"
                              style={{ backgroundColor: "#ebecedd7" }}
                              colSpan="2"
                            >
                              <input
                                type="date"
                                value={newBug.expectedDate}
                                name="expectedDate" className="form-control"
                                onChange={(e) =>
                                  setNewBug((prev) => ({
                                    ...prev,
                                    expectedDate: e.target.value,
                                  }))
                                }
                              />
                            </td>
                          </>
                        )}
                      </tr>
                      <br />
                      <tr className="mt-5" style={{ height: "60px" }}>
                        <th className="table-primary align-items-center">
                          Description
                        </th>
                        <td
                          style={{ backgroundColor: "#ebecedd7" }}
                          className=""
                          colSpan="6"
                        >
                          <input
                            type="text"
                            name="description"
                            id="description"
                            className="text-start form-control" required
                            value={newBug.bugDescription}
                            onChange={(e) =>
                              setNewBug((prev) => ({
                                ...prev,
                                bugDescription: e.target.value,
                              }))
                            }
                          />
                        </td>
                      </tr>
                      <tr>
  <td colSpan="7">
    <label htmlFor="note" className="fs-5">Add Note</label>
    <textarea
      type="text"
      name="note"
      id="note"
      className="w-100 p-2"
      value={newBug.note}
      onChange={(e) =>
        setNewBug((prev) => ({
          ...prev,
          note: e.target.value,
        }))
      }
    />
  </td>
</tr>
<tr>
  <td colSpan="7">
    <div
      className="upload-area"
      style={{
        border: "2px dashed #ccc",
        padding: "20px",
        width: "100%",
        textAlign: "center",
        position: "relative",
      }}
      onPaste={handlePaste} // Ensure this function is defined
    >
      <h4>Attach Screenshot or File</h4>
      <input
        type="file"
        accept="image/*"
        onChange={handlefile} // Ensure this function is defined
        id="file-input"
      />
      {preview && (
        <>
          <img
            src={preview}
            alt="preview"
            style={{
              maxWidth: "100%",
              maxHeight: "300px",
              marginTop: "10px",
              cursor: "pointer",
            }}
            //onClick={() => setShowModal(true)} // Trigger modal on click
          />
          {/* {showModal && (
            <div
              className="modal-overlay"
              onClick={() => setShowModal(false)} // Close modal on overlay click
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent modal from closing when clicking on the image
                style={{
                  position: "relative",
                  background: "#fff",
                  padding: "10px",
                  borderRadius: "8px",
                }}
              >
                <img
                  src={image}
                  alt="Full size"
                  style={{
                    maxWidth: "90vw",
                    maxHeight: "90vh",
                  }}
                />
                <button
                  onClick={() => setShowModal(false)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "red",
                    color: "#fff",
                    border: "none",
                    borderRadius: "50%",
                    width: "30px",
                    height: "30px",
                    cursor: "pointer",
                  }}
                >
                  ✕
                </button>
              </div>
            </div>
          )} */}
        </>
      )}
    </div>
  </td>
</tr>

                      <tr>
                        <td colSpan="7">
                          <button className="btn btn-warning w-100" type="submit">
                            Update Bug
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </form>
              )}
              {/* closed bug session */}
    </div>
  );
};

export default Bugs;
